export default "__VITE_ASSET__D3Fk6RrL__"